<pp-scrollable-shadow>
  <div class="wrapper fd-column">
    @for (section of conditions; track $index) {
      <div class="section fd-column">
        <div class="section-title">{{ section.name | translate }}</div>

        <div class="section-items fd-column">
          @for (item of section.items; track $index) {
            <div class="item d-flex-center">
              <div class="item-container">
                <div class="label pp-gray">
                  {{
                    'conditionsAndFees.dialog.block.card.item.label.name'
                      | translate
                  }}
                </div>
                <div class="key">{{ item.key | translate }}</div>
              </div>

              <div class="item-container">
                <div class="label pp-gray">
                  {{
                    'conditionsAndFees.dialog.block.card.item.label.fee'
                      | translate
                  }}
                </div>
                <div class="value">{{ item.value | translate }}</div>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
</pp-scrollable-shadow>
